import {
  fetch,
  normalize,
  extractHubURL,
  mercureSubscribe as subscribe
} from '../../utils/dataAccess';
import { success as deleteSuccess } from './delete';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'LIVEINTERVIEW_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'LIVEINTERVIEW_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'LIVEINTERVIEW_LIST_SUCCESS', retrieved };
}

export function list(page = 'live_interviews') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {

        dispatch(loading(false));
        dispatch(success(retrieved));

        if (hubURL && retrieved['hydra:member'].length)
          dispatch(
            mercureSubscribe(
              hubURL,
              retrieved['hydra:member'].map(i => i['@id'])
            )
          );
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch({ type: 'LIVEINTERVIEW_LIST_RESET' });
    dispatch(deleteSuccess(null));
  };
}

export function mercureSubscribe(hubURL, topics) {
  return dispatch => {
    const eventSource = subscribe(hubURL, topics);
    dispatch(mercureOpen(eventSource));
    eventSource.addEventListener('message', event =>
      dispatch(mercureMessage(normalize(JSON.parse(event.data))))
    );
  };
}

export function mercureOpen(eventSource) {
  return { type: 'LIVEINTERVIEW_LIST_MERCURE_OPEN', eventSource };
}

export function mercureMessage(retrieved) {
  return dispatch => {
    if (1 === Object.keys(retrieved).length) {
      dispatch({ type: 'LIVEINTERVIEW_LIST_MERCURE_DELETED', retrieved });
      return;
    }

    dispatch({ type: 'LIVEINTERVIEW_LIST_MERCURE_MESSAGE', retrieved });
  };
}

export function filter(filtersData) {
  return filterAction('LIVEINTERVIEW_LIST_FILTER', 'company_live_interview', filtersData)
}

export function sort(sortData) {
  return sortAction('LIVEINTERVIEW_LIST_SORT','company_live_interview', sortData)
}
